module.exports = __webpack_public_path__ + "img/mediaPackageCodes.b3c3cb74.svg";